{
  "schemaVersion": 1,
  "title": "Terrarium environment preview",
  "dimensionsMetres": [
    12,
    6,
    5.2
  ],
  "factoryExport": "createTerrariumScene",
  "reviewedFactorySHA256": "bfa569f080f8ee471237ca2644c23ed862ac98024cbec0d8aea0bb9de716fa9e",
  "sources": [
    {
      "path": "src/terrarium-scene/asset-comparison/scene-four-mass-family-ab.mjs",
      "sha256": "bfa569f080f8ee471237ca2644c23ed862ac98024cbec0d8aea0bb9de716fa9e",
      "bytes": 3050
    },
    {
      "path": "src/terrarium-scene/scene.mjs",
      "sha256": "c74c78678861d4ee049cb779e0081bdaffa60fd360d16a88cf21d0c92c367895",
      "bytes": 33984,
      "reviewedSourceSHA256": "ca8870ab24424195e1e41a00bdf0e29e4b062526059b6b6fa1d6175ec0a69c02",
      "publicRedaction": "Removed referenceLibraryId and sourceIds metadata only. Geometry, materials, lights and cameras unchanged."
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-fern-ab.mjs",
      "sha256": "3fa02fbcd12f22e5d646267f6d8ec4db426f2a8c0bd115cd9c75e3847783148a",
      "bytes": 1729
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-cohesive-ab.mjs",
      "sha256": "4cca80a152058c4ad20200bef52cf75edf83cd8e878b7af0d64bf30ae7a05d46",
      "bytes": 1881
    },
    {
      "path": "src/terrarium-scene/asset-comparison/reused-water-material.mjs",
      "sha256": "c16e2243bf96391c1b93b6495b8e81bfb37315091e840d60e9dc1191883fb51e",
      "bytes": 13671
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-depth-water-ab.mjs",
      "sha256": "8c443679946ef532b64a20201cb428671944a1c729b451d61dbe985b2ee20e38",
      "bytes": 2046
    },
    {
      "path": "src/terrarium-scene/asset-comparison/watercourse-slope-adapter.mjs",
      "sha256": "d8dcf55131282a2e7b5bdbe01cc8bab0685293840da8380541c893ca9aca2040",
      "bytes": 1256
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-seated-watercourse-ab.mjs",
      "sha256": "ee915ae71f4d0d5c4889437ee715552ee89da3039b793423d940fa3ca117f7d3",
      "bytes": 8757
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-compact-window-basin-ab.mjs",
      "sha256": "4c579beb0d371e7653ba75c4b53c219a2b7d260bfaf73bb66b186737a5835be7",
      "bytes": 11812
    },
    {
      "path": "src/terrarium-scene/asset-comparison/continuous-window-rock.mjs",
      "sha256": "8cf096e1f0f9e11b6770a0759e09325cd9bc2e735309c7c152a6dfd552e8e8bb",
      "bytes": 3167
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-continuous-window-basin-ab.mjs",
      "sha256": "ea9d908b37252441450ee5a2cc8e7097b9f0f6c5255412144c7714fb1aaebf5d",
      "bytes": 8441
    },
    {
      "path": "src/terrarium-scene/asset-comparison/scene-four-mass-window-basin-ab.mjs",
      "sha256": "40f471a1bf3ecd227dd09a5392fbdb612f24ac4ec28e5145d84f6dbb0fe64b8d",
      "bytes": 5283
    }
  ],
  "assets": {
    "rockSet": {
      "path": "assets/terrarium/rock-specimens.glb",
      "sha256": "4f7ac6ce04c5dc760fcff8c800190ea9301a12e90a3496d925c6c0e0ec3ac031",
      "bytes": 10708572
    },
    "substrate": {
      "path": "assets/terrarium/forest-substrate.glb",
      "sha256": "41f119f38576daa730321bde1344ae143a2e41601b97e2d621862bd8bf87ecd5",
      "bytes": 3800980
    },
    "ferns": {
      "path": "assets/terrarium/fern-02-cc0-alpha-correct.glb",
      "sha256": "87536aeb28651cfed0868ce7ed40da6b18a5961c260b232197459f5a05651bb6",
      "bytes": 1751732
    },
    "scanRocks": {
      "path": "assets/terrarium/rock-moss-set-01-cc0.glb",
      "sha256": "451599a92e375059fda4c11fc9265e35dde547df6dbc65a6f0572b4d72ae9e88",
      "bytes": 1933008
    },
    "rockSurface": {
      "path": "assets/terrarium/mossy-rock-tile-cc0.glb",
      "sha256": "5e03f8d10f053ad3c4b0c330b86bb633f28a07fc5c0ae784751d62357eb8e863",
      "bytes": 4341204
    }
  },
  "data": {
    "watercourse": {
      "path": "data/terrarium/watercourse-seated-stones.json",
      "sha256": "0259c5c3c4a158cf338f3df2725216c8fdd9ace82345a5c8deedfa2ec903cb32",
      "bytes": 1096
    },
    "fourMassComposition": {
      "path": "data/terrarium/four-mass-composition.json",
      "sha256": "e78edfcf269c398119cc35b825e575be2a650581d1e2742cded504f7ecbc675a",
      "bytes": 1783
    },
    "rockMaterialDirection": {
      "path": "data/terrarium/rock-family-direction.json",
      "sha256": "43417dabccd395fdf0c88f47bffdda3bcc83a18f140d38664bde82a873360717",
      "bytes": 881
    }
  },
  "previews": {
    "front": {
      "path": "assets/terrarium/front-preview.png",
      "sha256": "e2097734d245b0ba04bbaa3115875cbf4a6e98da027eb475bc6701e8f3edb1f0",
      "bytes": 729508,
      "label": "Front view \u00b7 final material-family treatment"
    }
  }
}
